<template>
  <UModal
    :title="title"
    :class="ui?.root"
    :close="{
      onClick: () => emit('close', false),
    }"
    :ui="{
      title:
        'typo-heading-h3 text-modal-title leading-h1-paragraph whitespace-normal max-w-83.5 max-md:mb-0',
      header:
        ' pr-10! whitespace-normal border-b-0 pb-2.5 max-md:p-5 max-md:pr-18! max-md:pb-2.5 max-md:min-h-auto',
      body: 'typo-paragraph-sm-regular font-lato pt-0! max-md:p-5 max-md:pr-18 text-content-default-secondary',
    }"
  >
    <template #close>
      <UButton
        class="absolute w-8 h-8 top-6 right-6 max-md:top-5 max-md:right-5 text-neutral-default"
        variant="outline"
        icon="i-local-close"
        color="neutral"
        size="sm"
        @click="emit('close', false)"
      />
    </template>

    <template #body>
      <p class="description" :class="ui?.description">{{ description }}</p>
    </template>
  </UModal>
</template>

<script lang="ts" setup>
defineOptions({
  name: 'SuccessModal',
})

const emit = defineEmits<{ close: [boolean] }>()

defineProps<{
  title: string
  description?: string
  ui?: {
    root?: string
    description?: string
  }
}>()
</script>
